import { render, staticRenderFns } from "./Star5.vue?vue&type=template&id=3656092a&"
import script from "./Star5.vue?vue&type=script&lang=js&"
export * from "./Star5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/one-stop-shop/one-stop-shop/one-stop-shop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3656092a')) {
      api.createRecord('3656092a', component.options)
    } else {
      api.reload('3656092a', component.options)
    }
    module.hot.accept("./Star5.vue?vue&type=template&id=3656092a&", function () {
      api.rerender('3656092a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/wp-content/themes/global-theme/views/pages/productAside/Heading/stars/Star5.vue"
export default component.exports